
<template>
    <div
        v-if="!$wait.is('loading-page')"
        class="m-products m-products__list"
    >
        <y-container>
            <y-row>
                <y-col
                    lg="3"
                    md="4"
                    sm="12"
                >
                    <y-market-filter
                        type="simple"
                        :parent-category="true"
                    />
                </y-col>

                <y-col
                    lg="9"
                    md="8"
                    sm="12"
                >
                    <y-row>
                        <y-col>
                            <y-market-sort type="simple" />
                        </y-col>
                    </y-row>

                    <y-list-wrapper
                        v-if="posts.items && posts.items.length"
                        type="grid"
                        v-bind="posts"
                    />
                    <y-empty
                        v-else
                        reverse
                        :src="require('@/assets/images/products-empty.svg')"
                        :title="$t('products.empty')"
                    />

                    <y-row
                        v-if="lastPage > 1"
                        class="d-flex align-items-center justify-content-center"
                    >
                        <y-pagination
                            :last-page="lastPage"
                            color="primary"
                        />
                    </y-row>
                </y-col>
            </y-row>
        </y-container>
    </div>
</template>

<script>

    import {
        YMarketFilter,
        YMarketSort,
        YListWrapper,
    } from '@rogues';
    import { YPagination, YEmpty } from '@components';
    import PageMixin from '@nodes/mixins/Page';
    import ProductsMixin from '@nodes/mixins/Products';

    export default {

        name: 'ProductsList',

        components: {
            YPagination,
            YMarketFilter,
            YMarketSort,
            YListWrapper,
            YEmpty,
        },

        mixins: [PageMixin, ProductsMixin],

        /**
         * @inheritDoc
         */
        data() {
            return {
                posts: {
                    class    : 'mb-12',
                    component: {
                        classes     : 'mt-5',
                        name        : 'YProductCard',
                        type        : 'Picture',
                        imageVersion: 'main',
                        addToCart   : true,
                        listeners   : {
                            'click:addToCart': (item) => {
                                this.addToCart(item);
                            },
                        },
                    },
                    noScroll: true,
                    col     : {
                        xs: '12',
                        sm: '6',
                        md: '4',
                    },
                },

                tagging : null,
                lastPage: null,
            };
        },

        /**
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.title,
            };
        },

        computed: {
            /**
             * Check if current page is category page
             *
             * @returns {boolean}
             */
            isCategoryPage() {
                return this.$route.name === 'products-category';
            },

            /**
             * Check if current page is tag page
             *
             * @returns {boolean}
             */
            isTagPage() {
                return this.$route.name === 'products-tag';
            },
           
            /**
             * Page title
             * 
             * @returns {string}
             */
            title() {
                if (this.isCategoryPage) {
                    return this.$t('products.titles.category', [this.tagging]);
                }
                if (this.isTagPage) {
                    return this.$t('products.titles.tag', [this.tagging]);
                }
                return this.$t('products.titles.list');
            },
        },

        methods: {
            /**
             * Fetch products data
             * 
             * @returns {Promise}
             */
            fetch() {
                this.tagging = null;
                this.lastPage = null;

                // Params default
                const params = {
                    ...this.$route.query,
                    type     : 'products',
                    including: ['id', 'title', 'image', 'ware_is_available', 'ware_original_price', 'ware_sale_price', 'url_encode'],
                    locale   : this.$i18n.locale,
                    paginated: 1,
                    page     : this.$route.query.page || 1,
                    order    : this.$route.query.order || 'desc',
                };

                // Check for categories or tags
                if (this.isCategoryPage || this.isTagPage) {
                    params.tagging = [this.$route.params.url_encode];
                }

                if (this.$route.query?.tagging_group) {
                    if (Array.isArray(this.$route.query.tagging_group)) {
                        params.tagging_group = this.$route.query.tagging_group;
                    } else {
                        params.tagging_group = [this.$route.query.tagging_group];
                    }
                }

                return this.$services.Content.postList(params).then((response) => {
                    this.posts = {
                        ...this.posts,
                        limit: response.data.metadata.per_page,
                        items: response.data.results,
                    };
                    this.tagging = this.get(response.data.metadata, 'elected_taggings.0.title');
                    this.lastPage = response.data.metadata.last_page;
                }).catch((error) => {
                    this.handleError(error);
                });
            },
        },

    };
</script>
